import { render, staticRenderFns } from "./InstanceName.vue?vue&type=template&id=61e599e0&scoped=true&"
import script from "./InstanceName.vue?vue&type=script&lang=js&"
export * from "./InstanceName.vue?vue&type=script&lang=js&"
import style0 from "./InstanceName.vue?vue&type=style&index=0&id=61e599e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e599e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e599e0')) {
      api.createRecord('61e599e0', component.options)
    } else {
      api.reload('61e599e0', component.options)
    }
    module.hot.accept("./InstanceName.vue?vue&type=template&id=61e599e0&scoped=true&", function () {
      api.rerender('61e599e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/InstanceName.vue"
export default component.exports